import { Injectable } from '@angular/core';
import { Http, Response , Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';

@Injectable()
export class NhanVienService {
    controller:string = 'NhanVien';   
    constructor(private http: Http) { }
      
    GetList(paging:number,maxSize:number, keyword: string, IdDonVi:number) {
        let headers = new Headers(); 
        let currentPage = paging - 1;      
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));      
        return this.http.get(Config.apiUrl + this.controller+ "/GetList?currentPage="+ currentPage+"&maxSize="+ maxSize + "&keyword=" + keyword + "&IdDonVi=" + IdDonVi, { headers: headers }).map(resp => resp.json());               
    }
    GetList1(paging:number,maxSize:number, keyword: string, IdDonVi:number, Ids:string, xphc: number) {
        let headers = new Headers(); 
        let currentPage = paging - 1;      
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));      
        return this.http.get(Config.apiUrl + this.controller+ "/GetList1?currentPage="+ currentPage+"&maxSize="+ maxSize + "&keyword=" + keyword + "&IdDonVi=" + IdDonVi +"&Ids="+Ids + "&xphc=" + xphc, { headers: headers }).map(resp => resp.json());               
    }
    DanhSachNhanVien_CoQuan(IdCoQuan) {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdCoQuan:IdCoQuan};
        return this.http.post(Config.apiUrl + this.controller+'/GetList_CoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());               
    }
    DanhSachNhanVien_DonViCon(IdDonVi) {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdDonVi:IdDonVi};
        return this.http.post(Config.apiUrl + this.controller+'/GetList_DonViCon', JSON.stringify(data), { headers: headers }).map(resp => resp.json());               
    }
    GetItem(ids:string) {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {Ids:ids};
        return this.http.post(Config.apiUrl + this.controller+'/GetItem', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
               
    }
    Save(NV) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = NV;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }    
    uploadFile(formData: FormData) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'NhanVien/UploadFile', formData, { headers: headers }).map(resp => resp.json());
    }
    SaveNoAvatar(item) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/SaveNoAvatar', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Update(fileList: FileList, item){
        let headers = new Headers();
        //headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let options = new RequestOptions({ headers: headers });
        let formData:FormData = new FormData();
        let file: File = fileList[0];            
        formData.append('uploadFile', file, file.name);    
        formData.append('Id', item.Id);
        formData.append('Ids', item.Ids);
        formData.append('HoTen', item.HoTen);
        formData.append('NgaySinh', item.NgaySinh);
        formData.append('GioiTinh', item.GioiTinh);
        //formData.append('FileVanBan', item.FileVanBan);
        formData.append('Cmnd', item.Cmnd);
        formData.append('DienThoai', item.DienThoai);
        formData.append('Email', item.Email);
        formData.append('Otp', item.Otp);
        return this.http.post(Config.apiUrl + this.controller+'/Update', formData, options).map(resp => resp.json());
    }

    capUser(item){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+ '/CapTaiKhoan', JSON.stringify(item), {headers: headers}).map(resp=>resp.json());
    }

    getDSQuyen(nv){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/listroles', JSON.stringify(nv), {headers: headers}).map(resp=>resp.json());
    }

    capQuyen(dsQuyen){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/capquyen', JSON.stringify(dsQuyen), {headers: headers}).map(resp=>resp.json());
    }
    getListDonVi(idTinhThanh){
            let headers = new Headers();
            headers.append("Content-Type", "application/json;charset=utf-8");
            headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
            var data = {
                IdTinhThanh: idTinhThanh
            };
            return this.http.post(Config.apiUrl + 'Donvi/DSDonVi', JSON.stringify(data), {headers: headers})
                .map((response) => response.json());
   }
   Huy_NhanVien(NV) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = NV;
        return this.http.post(Config.apiUrl + this.controller+'/Huy_NhanVien', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachDonVi(IdCoQuan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdCoQuan:IdCoQuan};
        return this.http.post(Config.apiUrl + 'DMDonVi/GetTreeDonVi_TheoCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Luu_KiemNhiem(KNhiem) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = KNhiem;
        return this.http.post(Config.apiUrl + 'NhanVien/Luu_KiemNhiem', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Huy_KiemNhiem(KNhiem) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = KNhiem;
        return this.http.post(Config.apiUrl + 'NhanVien/Huy_KiemNhiem', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_KiemNhiem(KNhiem) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = KNhiem;
        return this.http.post(Config.apiUrl + 'NhanVien/DanhSach_KiemNhiem', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_DonVi(NV) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = NV;
        return this.http.post(Config.apiUrl + 'NhanVien/TimKiemTree', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Danhsach_NhanVienALL(iddonvi: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.get(Config.apiUrl + 'NhanVien/DanhSachNhanVienAll?iddonvi=' + iddonvi, { headers: headers }).map(resp => resp.json());
    }
    DS_NhanVienKiemNhiemDonVi(IdDonVi) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdDonVi:IdDonVi};
        return this.http.post(Config.apiUrl + 'NhanVien/DS_NhanVienKiemNhiem_DonVi', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_TinhThanh(idcoquan:number, idtinhthanh:number){
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdCoQuan:idcoquan,
            IdTinhThanh:idtinhthanh
        };
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/ds_tinhthanh', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
      }
    ds_QuanHuyen(idtinhthanh){
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdTinhThanh:idtinhthanh
        };
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListQuanHuyenYC', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
      }
  
    ds_PhuongXa(idtinhthanh, idquanhuyen,idnhanvien){
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdTinhThanh:idtinhthanh, 
            IdQuanHuyen:idquanhuyen,
            IdNhanVien: idnhanvien
        };
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListPhuongXaNVDB', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_NhanVienDiaBan(TT) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TT;
        return this.http.post(Config.apiUrl + 'NhanVien/luu_NhanVienDiaBan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_NhanVienDiaBan(idnhanvien:number, ids: string) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdNhanVien:idnhanvien,
            Ids:ids
        };
        return this.http.post(Config.apiUrl + 'NhanVien/ds_NhanVienDiaBan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_NhanVienLinhVuc(idnhanvien:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdNhanVien:idnhanvien
        };
        return this.http.post(Config.apiUrl + 'NhanVien/ds_NhanVienLinhVuc', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_NhanVienLinhVuc(TT) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TT;
        return this.http.post(Config.apiUrl + 'NhanVien/luu_NhanVienLinhVuc', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    phanQuyenXPHC(data: any) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/phanquyenxphc', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    ds_NhanVienQuyenXPHC(idnhanvien:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdNhanVien:idnhanvien
        };
        return this.http.post(Config.apiUrl + 'NhanVien/ds_NhanVienQuyenXPHC', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_NhanVienQuyenXPHC(TT) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TT;
        return this.http.post(Config.apiUrl + 'NhanVien/luu_NhanVienQuyenXPHC', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    DoiMatKhau(data: any){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/change-password', JSON.stringify(data), {headers: headers}).map(resp=>resp.json());
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/he-thong/nhan-vien/nhan-vien.service.ts